export const ADD_HABIT = 'features/Habit/ADD_HABIT'; 
export const REMOVE_HABIT = 'features/Habit/REMOVE_HABIT'; 
export const SET_RECURRENCE = 'features/Habit/SET_RECURRENCE';
export const SET_ID = 'features/Habit/SET_ID';

export const HABIT_TYPE = {
  DO: 'DO', 
  DONT: 'DONT'
}
